<script setup>

import {inject} from 'vue'
import axios from "axios";
import Notification from "@/classes/component-classes/Notification";
import NoDataFoundBanner from "@/components/shipments/NoDataFoundBanner";
import BusySpinner from "@/components/common/other/BusySpinner";

import {useStore} from 'vuex';
import {useDownloadLocalFile} from "@/composables/common/useDownloadLocalFile";

const store = useStore();

const shipments = inject("shipments");

function downloadDocument(doc) {

  doc.isDownloading = true;

  axios.get('Shipments/document', {

    responseType:'blob',
    params: {
      owner: store.state.owner,
      id: doc.id
    }

  }).then((response) => {

    if(response) {

      useDownloadLocalFile(response);
      doc.downloaded = true;
      doc.isDownloading = false;
    }

  }).catch(function (error) {

    shipments.value.shipmentErrorLogs.push(error);
    store.state.banners.error = new Notification(true, 'Could Not Perform Download');

    doc.isDownloading = false;

  });
}

</script>

<template>
  <div class="cmp-shipment-document-download_wrapper" v-if="shipments.shipmentDocs.length > 0" >
    <div class="cmp-shipment-document-download_headers">
      <div>Quote Number</div>
      <div>Invoice Number</div>
      <div>Title</div>
      <div>Comments</div>
      <div> Download</div>
      <div></div>
    </div>
    <div class="cmp-shipment-document-download_list-wrapper">
      <div v-for="doc in shipments.shipmentDocs" :key="doc.id" class="cmp-shipment-document-download_data-boxes-wrapper">
        <div id="boxes" style="width: 100px;" :title="doc.quoteNumber">{{doc.quoteNumber}}</div>
        <div id="boxes" style="width: 105px;" :title="doc.invoiceNumber">{{doc.invoiceNumber}}</div>
        <div id="boxes" style="width: 240px;" :title="doc.name">{{doc.name}}</div>
        <div id="boxes" style="width: 205px;" :title="doc.description">{{doc.description}}</div>
        <div v-if="!doc.downloaded && !doc.isDownloading" @click="downloadDocument(doc)" class="cmp-shipment-document-download_download-icon">
          <i class="fa-regular fa-cloud-arrow-down"></i>
        </div>
        <div v-else-if="doc.downloaded" class="cmp-shipment-document-download_downloaded-icon"><i class="fa-regular fa-file-check"></i>
        </div>
        <div v-if="doc.isDownloading" class="cmp-shipment-document-download_busy-downloader">
          <BusySpinner :hide="!doc.isDownloading" message=""></BusySpinner>
        </div>
      </div>
    </div>
  </div>
  <div v-else style="width: 600px"><NoDataFoundBanner>No Documents Found</NoDataFoundBanner></div>
</template>

<style lang="scss" scoped>

.cmp-shipment-document-download {

  &_wrapper {
    font-size: 13px;
    height: 124px;
    width: 860px;
  }

  &_list-wrapper {
    margin-top: 10px;
    height: 100px;
    overflow-y: scroll;
  }

  &_headers {
    display: grid;
    grid-template-columns: 130px 135px 270px 220px 100px;
    padding: 4px;
    font-weight: bold;
  }

  &_data-boxes-wrapper {
    display: flex;
    gap: 20px;
  }

  &_data-boxes-wrapper #boxes {
    display: flex;
    align-items: center;
    height: 16px;
    border: 1px solid #e7e7e7;
    padding: 5px;
    margin-top: 5px;
    border-radius: 2px;
    overflow: hidden;
    white-space: nowrap;
    background: #fff;
    border-radius: 8px;
  }

  &_download-icon {
    display: flex;
    align-items: center;
    color: #F68E1E;
    font-size: 18px;
    border: none!important;
    cursor: pointer;
    background: #fdfdfd!important;
    //margin-left: 5px;
  }

  &_download-icon:hover {
    color: #0b3080;
  }

  &_downloaded-icon {
    display: flex;
    align-items: center;
    color: #288a49;
    font-size: 20px;
    margin-left: 3px;
  }

  &_busy-downloader {
    border: none!important;
    background: #fdfdfd!important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

</style>
